import { Link } from "gatsby";
import styled from "styled-components";
import { LinkStyle, SParagraph } from "../../common";

export const MarkdownLink = styled(Link)`
  ${SParagraph}
  ${LinkStyle}
`;
